import { createFileRoute } from '@tanstack/react-router'
import { JobEdit } from '@/features/jobs/job-edit'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/edit')({
  component: JobEdit,
})
